import styled from 'styled-components'


export const BackgroundDiv = styled.div`
width: 100vw;
height: 100%;
min-height: 100vh;
position: fixed;
top: 0;
left: 0;
background-color: #EEEFF0;
z-index: -99;
`